import { defineFcm } from '../shared/factory';

export const FCM_FOOTER_NONPROFIT_LINK = defineFcm('footer_nonprofit_link').asBoolean().withDefault(false).toConfig({
	owner: 'squad-dolphin',
	scope: 'corgi-front-end',
	context: 'Get involved',
	description: 'Shows the Nonprofits link in the footer "Get involved" section.',
	import: false,
});
